export default ({ Link: { link, target, type } = {}, label }) => {
	return {
		link,
		target,
		type,
		label,
	};
};
